module.exports = __webpack_public_path__ + "img/ABRAZADERA INDUSTRIAL.6bf08692.jpg";